import { render, staticRenderFns } from "./RentKebabView.vue?vue&type=template&id=4a15296e&"
import script from "./RentKebabView.vue?vue&type=script&lang=js&"
export * from "./RentKebabView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports